import React from 'react';

import LinearProgress from '@/components/ui-bridge/core/LinearProgress';

const ScreenLoading = () => (
  <div className="w-full min-h-[4px]">
    <LinearProgress />
  </div>
);

export default ScreenLoading;
